import { DataSource } from '@n7-frontend/core';
import { IChartData } from '@n7-frontend/components';
import { Utils } from './utils';
export class CentralityScoreDS extends DataSource {
  protected transform(data): IChartData {
    if (!data || !data.userData.cervedIndicators || !data.userData.cervedIndicators || !data.userData.cervedIndicators.centralityScore) {
      return;
    }

    const centralityScore = data.userData.cervedIndicators.centralityScore;
    const values = !!centralityScore && !!centralityScore.value ? [centralityScore.value] : [];
    const labels = !!centralityScore && !!centralityScore.label ? [centralityScore.label] : []; 
    if (!values.length) {
      return {
        containerId: null,
        libOptions: null,
        payload: { loaded: true }
      };
    }

    const chartOption = {
      series: values,
      chart: {
        id: 'centrality-score-chart',
        type: 'radialBar',
        height: 270,
        toolbar: {
          show: false
        }
      },
      plotOptions:  {
          radialBar: {
            startAngle: -120,
            endAngle: 120,
             hollow: {
              margin: 0,
              size: '70%',
              background: '#fff',
              position: 'front',
              dropShadow: {
                enabled: false
              }
            },
            track: {
              background: '#f4f4f4',
              strokeWidth: '90%',
              margin: 0, // margin is in pixels
              dropShadow: {
                enabled: false
              }
            },
            dataLabels: {
              name: {
                fontSize: '18px',
                fontFamily: 'Open Sans',
                color: '#888',
                offsetY: 96
              },
              value: {
                offsetY: 50,
                fontSize: '28px',
                fontFamily: 'Open Sans',
                fontWeight: 'bold',
                color: '#111',
                formatter: function (val) {
                  return val + "%";
                }
              }
            }
          }
        },
        fill: {
          type: 'image',
          image: {
            src: ['../../../assets/images/chart-bg.png'],
          }
        },
        stroke: {
          dashArray: 3
        },
        labels: ['Score'],
        noData: {
          text: 'Dato non disponibile',
          align: 'center',
          verticalAlign: 'middle',
          offsetX: 0,
          offsetY: 0,
          style: {
            color: '#474747',
            fontSize: '14px',
            fontFamily: 'Open Sans'
          }
        }
      }
    return {
      containerId: 'centrality-score-chart',
      libOptions: chartOption,
      payload: { loaded: true }
    };

  }
}
